<template>
  <DataTable :value="licenseDataJSON" :show-gridlines="true" style="min-height: 200px">
    <Column field="name" header="Package" />
    <Column field="version" header="Version" />
    <Column field="license" header="License" />
  </DataTable>
</template>

<script lang="ts" setup>
import licenseDataJSON from '@/../licenses.json'
</script>
